import React, { useContext } from 'react';

// CONTEXT
import { ToastContext } from 'context/ToastContext';

// COMPONENTS
import TooltipComponent from '../tooltipComponent';
import TileSpecificInfo from './TileSpecificInfo';

// SERVICES
import { insertTileStat } from 'services/statService';

const LinkTile = ({ user_id, tile_id, title, desc, url, isPrivate, imageUrl, onPrivateClick, isEditing = false, isViewing = false, userEmail = null, currentBreakpoint = 'lg', disableKamaeFetch = false }) => {
  const { addToast } = useContext(ToastContext);

  const shouldShowImage = () => {
    // Masquer l'image en mode xs (mais pas en xxs)
    return currentBreakpoint !== 'xs';
  };

  const handleClick = (e) => {
    if (isPrivate) {
      e.preventDefault();
      addToast('Connexion au réseau', 'Oups ! Il semble que vous ne soyez pas connecté au réseau de l\'entreprise', () => openFortiClient(), 'Activer le VPN', 'warning');
      if (onPrivateClick) {
        onPrivateClick();
      }
    } else {
      insertTileStat(user_id, tile_id);
    }
  };

  const openFortiClient = () => {
    window.location.href = 'forticlient://open';
  };

  // Tailles responsives selon le breakpoint
  const getResponsiveClasses = () => {
    const isXs = currentBreakpoint === 'xs';
    const isSm = currentBreakpoint === 'sm';
    const isMd = currentBreakpoint === 'md';
    
    return {
      padding: isXs ? 'p-1.5' : isSm ? 'p-2' : isMd ? 'p-2.5' : 'p-3',
      imageSize: isXs ? 'w-6 h-6' : isSm ? 'w-8 h-8' : isMd ? 'w-9 h-9' : 'w-10 h-10',
      imageRounded: isXs ? 'rounded-lg' : 'rounded-xl',
      titleSize: isXs ? 'text-[10px]' : isSm ? 'text-[10px]' : isMd ? 'text-xs' : 'text-xs sm:text-sm',
      descSize: isXs ? 'text-[9px]' : isSm ? 'text-[10px]' : isMd ? 'text-[11px]' : 'text-[11px]',
      gap: isXs ? 'gap-0.5' : isSm ? 'gap-1' : 'gap-1',
      topRight: isXs ? 'top-0.5 right-0.5' : isSm ? 'top-1 right-1' : 'top-1.5 right-1.5',
      lineClamp: 'line-clamp-2',
    };
  };

  const responsive = getResponsiveClasses();

  return (
    <>
    {!isEditing && !isViewing ? (
      <TooltipComponent title={desc} placement="bottom">
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={`w-full h-full ${responsive.padding} rounded-lg flex flex-col justify-between relative overflow-hidden`}
          style={{ textDecoration: 'none' }}
          onClick={handleClick}
        >
          {/* Affichage des informations spécifiques à la tuile en haut à droite */}
          <div className={`absolute ${responsive.topRight} z-10`}>
            <TileSpecificInfo 
              tileTitle={title} 
              userEmail={userEmail}
              currentBreakpoint={currentBreakpoint}
              disableFetch={disableKamaeFetch}
            />
          </div>

          {/* Logo en haut à gauche */}
          {imageUrl && shouldShowImage() && (
            <div className={`${responsive.imageSize} ${responsive.imageRounded} overflow-hidden shadow-md`}>
              <img 
                src={imageUrl} 
                alt={title} 
                className="w-full h-full object-cover" 
              />
            </div>
          )}

          {/* Texte en bas */}
          <div className={`flex flex-col ${responsive.gap} mt-auto`}>
            <h3 className={`${responsive.titleSize} poppins-bold text-blanc overflow-hidden text-ellipsis line-clamp-1`}>
              {title}
            </h3>
            {desc && currentBreakpoint !== 'xs' && (
              <p className={`${responsive.descSize} text-blanc/80 overflow-hidden ${responsive.lineClamp}`} style={{ 
                display: '-webkit-box', 
                WebkitLineClamp: 2, 
                WebkitBoxOrient: 'vertical' 
              }}>
                {desc}
              </p>
            )}
          </div>
        </a>
      </TooltipComponent>
    ) : (
      <div className={`w-full h-full ${responsive.padding} rounded-lg flex flex-col justify-between relative overflow-hidden`}>
        {/* Affichage des informations spécifiques à la tuile en haut à droite (mode édition/visualisation) */}
        <div className={`absolute ${responsive.topRight} z-10`}>
          <TileSpecificInfo 
            tileTitle={title} 
            userEmail={userEmail}
            currentBreakpoint={currentBreakpoint}
            disableFetch={disableKamaeFetch}
          />
        </div>

        {/* Logo en haut à gauche */}
        {imageUrl && shouldShowImage() && (
          <div className={`${responsive.imageSize} ${responsive.imageRounded} overflow-hidden shadow-md`}>
            <img 
              src={imageUrl} 
              alt={title} 
              className="w-full h-full object-cover" 
            />
          </div>
        )}

        {/* Texte en bas */}
        <div className={`flex flex-col ${responsive.gap} mt-auto`}>
          <h3 className={`${responsive.titleSize} poppins-bold text-blanc overflow-hidden text-ellipsis line-clamp-1`}>
            {title}
          </h3>
          {desc && currentBreakpoint !== 'xs' && (
            <p className={`${responsive.descSize} text-blanc/80 overflow-hidden ${responsive.lineClamp}`} style={{ 
              display: '-webkit-box', 
              WebkitLineClamp: 2, 
              WebkitBoxOrient: 'vertical' 
            }}>
              {desc}
            </p>
          )}
        </div>
      </div>
    )}
    </>
  );
};

export default LinkTile;